import React from 'react';
import { Color } from '../../utils';

import styles from './styles.module.css';

interface ScoreProps {
  color: Color;
  label: string;
  value: string;
}

const Score = (props: ScoreProps) => {
  return (
    <div className={`${styles['score']} ${styles[props.color]}`}>
      <p>{props.label}</p>
      <h2>{props.value}</h2>
    </div>
  );
}

export default Score;